import React, { useState } from 'react';
import { ImageOff } from 'lucide-react';

export default function PhotoImage(props) {
  return <ImageResource key={props.src} {...props} />;
}

function ImageResource({ src, alt, className = '', retry = false, reveal = true, loading = 'lazy', ...props }) {
  const [failed, setFailed] = useState(false);
  const [ready, setReady] = useState(!reveal);
  const [attempt, setAttempt] = useState(0);
  if (failed) return <div className={`${className} image-unavailable`} style={props.style} role="group" aria-label={`${alt}: image unavailable`}>
    <ImageOff className="w-7 h-7 shrink-0" aria-hidden="true" />
    <span className="text-sm">Image unavailable</span>
    {retry && <button className="filter-pill" onClick={() => { setFailed(false); setReady(false); setAttempt(n => n + 1); }}>Retry image</button>}
  </div>;
  return <img {...props} key={attempt} src={src} alt={alt} loading={loading} decoding="async"
    className={`${className} ${ready && reveal ? 'image-arrived' : ''}`}
    style={{ ...props.style, opacity: ready ? undefined : 0 }}
    onLoad={async event => {
      const image = event.currentTarget;
      try { await image.decode(); } catch { /* onLoad already confirms a usable image. */ }
      setReady(true);
    }}
    onError={() => setFailed(true)} />;
}
